<template>
  <v-card tile flat style="padding: 16px 24px 16px; overflow: hidden;">
    <edit-filter
      class="pt-2"
      v-model="data"
      :fields="fields"
      @input="onChangeValue"
    ></edit-filter>
  </v-card>
</template>

<script>
import EditFilter from './tab/edit-tab-filter.vue'
export default {
  components: { EditFilter },
  props: {
    value: {},
    layer: {},
    fields: { type: Array },
  },
  data: () => ({
    data: [],
  }),
  watch: {
    value: {
      handler(value) {
        this.data = value || []
      },
      immediate: true,
    },
  },
  methods: {
    onChangeValue(value) {
      this.$emit('input', value)
    },
  },
}
</script>
